/// <amd-module name="Core/Medius.Core.Web/Scripts/components/sendEmailDialog/richTextInput/menuBar"/>
import * as React from "react";
import { 
    Button, 
    IconEditingClearFormatting,
    IconEditingListBulletsRegular,
    IconEditingListNumbersRegular,
    IconEditingTextBRegular,
    IconEditingTextItalicRegular,
    IconEditingTextUnderlineRegular
} from "@medius/ui-controls";
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";
import type { Editor } from "@tiptap/react";
import { useEditorState } from "@tiptap/react";

export interface MenuBarProps {
    editor: Editor;
}
export const MenuBar = (props: MenuBarProps) => {
    const {editor} = props;

    const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isBold: ctx.editor.isActive("bold") ?? false,
        canBold: ctx.editor.can().chain().toggleBold().run() ?? false,
        isItalic: ctx.editor.isActive("italic") ?? false,
        canItalic: ctx.editor.can().chain().toggleItalic().run() ?? false,
        isUnderline: ctx.editor.isActive("underline") ?? false,
        canUnderline: ctx.editor.can().chain().toggleUnderline().run() ?? false,
        isBulletList: ctx.editor.isActive("bulletList") ?? false,
        isOrderedList: ctx.editor.isActive("orderedList") ?? false,
      };
    },
  });

  const boldLabel = translate("#Core/textFormatBold");
  const italicLabel = translate("#Core/textFormatItalic");
  const underlineLabel = translate("#Core/textFormatUnderline");
  const bulletListLabel = translate("#Core/textFormatBulletList");
  const orderedListLabel = translate("#Core/textFormatOrderedList");
  const clearFormattingLabel = translate("#Core/textFormatClearFormatting");

  return (
    <div style={{display: "flex", gap: "8px"}}>
      <Button
        icon={<IconEditingTextBRegular />}
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editorState.canBold}
        variant={editorState.isBold ? "primary" : "inline"}
        hideLabel
        label={boldLabel}
        description={boldLabel}
      />
      <Button
        icon={<IconEditingTextItalicRegular />}
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!editorState.canItalic}
        variant={editorState.isItalic ? "primary" : "inline"}
        hideLabel
        label={italicLabel}
        description={italicLabel}
      />
      <Button
        icon={<IconEditingTextUnderlineRegular />}
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        disabled={!editorState.canUnderline}
        variant={editorState.isUnderline ? "primary" : "inline"}
        hideLabel
        label={underlineLabel}
        description={underlineLabel}
      />
      <Button
        icon={<IconEditingListBulletsRegular />}
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        variant={editorState.isBulletList ? "primary" : "inline"}
        hideLabel
        label={bulletListLabel}
        description={bulletListLabel}
      />
      <Button
        icon={<IconEditingListNumbersRegular />}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        variant={editorState.isOrderedList ? "primary" : "inline"}
        hideLabel
        label={orderedListLabel}
        description={orderedListLabel}
      />
      <Button
        icon={<IconEditingClearFormatting />}
        onClick={() => editor.chain().focus().unsetAllMarks().clearNodes().run()}
        variant="inline"
        hideLabel
        label={clearFormattingLabel}
        description={clearFormattingLabel}
      />
    </div>
  );
};
